import { ID_REGISTER } from 'civil-status/components/shared/list-register';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformerSeperazione = (values?: ModelEventoDTO): SectionVM | undefined => {
  const accordoSeparazione = values?.separazione?.accordoSeparazione;

  if (!accordoSeparazione) {
    return;
  }

  const typeAct = Boolean(accordoSeparazione?.idAnsc)
    ? CodeTypeAct.attoDigitale
    : CodeTypeAct.attoCartaceo;

  return {
    typeAct,
    actForm: {
      idAnsc: accordoSeparazione?.idAnsc,
      dateAct: accordoSeparazione?.dataformazione
        ? DateTime.fromISO(accordoSeparazione?.dataformazione)
        : null,
      italian: accordoSeparazione?.idComuneRegistrazione
        ? {
            municipality: {
              id: accordoSeparazione?.idComuneRegistrazione || '',
              code: accordoSeparazione?.idComuneRegistrazione
                ? Number.parseInt(accordoSeparazione?.idComuneRegistrazione, 10)
                : undefined,
              description: accordoSeparazione.nomeComuneRegistrazione || '',
              province: accordoSeparazione.siglaProvinciaRegistrazione || '',
              idProvince: accordoSeparazione.idProvinciaRegistrazione
                ? Number.parseInt(accordoSeparazione.idProvinciaRegistrazione, 10)
                : undefined,
            },
          }
        : undefined,
      register: ID_REGISTER.MATRIMONIO,
      year: accordoSeparazione?.annoAtto || '',
      municipalNumber: accordoSeparazione?.numeroatto || '',
      typeEvent: accordoSeparazione?.idtipocontenuto || '',
      //   portion: values?.parte || '',
      //   serie: values?.serie || '',
      //   volume: values?.volume || '',
    },
  };
};
